/* TOC scroll-spy + figure CI tooltip + smooth scroll
   Vanilla. No framework. */
(function () {
  'use strict';

  // ── TOC scroll-spy ────────────────────────────────────────
  const tocLinks = Array.from(document.querySelectorAll('.toc-list a[href^="#"]'));
  const sections = tocLinks
    .map(a => document.querySelector(a.getAttribute('href')))
    .filter(Boolean);

  if (sections.length) {
    let activeId = sections[0].id;
    const setActive = (id) => {
      if (id === activeId) return;
      activeId = id;
      tocLinks.forEach(a => {
        a.classList.toggle('is-active', a.getAttribute('href') === '#' + id);
      });
    };

    // Choose the section whose top is closest above viewport center
    const onScroll = () => {
      const target = window.innerHeight * 0.28;
      let best = sections[0];
      let bestDist = Infinity;
      for (const sec of sections) {
        const top = sec.getBoundingClientRect().top;
        if (top <= target) {
          const d = target - top;
          if (d < bestDist) { bestDist = d; best = sec; }
        }
      }
      setActive(best.id);
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Year stamp ────────────────────────────────────────────
  document.querySelectorAll('[data-year]').forEach(el => {
    el.textContent = new Date().getFullYear();
  });
})();
